import React, { Component } from 'react';
import { connect } from 'react-redux';
import LinkedAccountModalView from './LinkedAccountModal.view';
import { generateAccount } from './LinkedAccount.util';

export class LinkedAccountModalContainer extends Component {

  constructor(props) {
    super(props);

    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.submitForm = this.submitForm.bind(this);

    this.state = {
      formState: {
        data: {},
      },
      type: null,
    };
  }

  componentDidMount() {
    const { editingLinkedAccount } = this.props;
    const type = editingLinkedAccount.isLinked ? 'update' : 'create';

    const balanceSellingAccount = editingLinkedAccount.balanceSellingAccount;
    const data = generateAccount(editingLinkedAccount, balanceSellingAccount);
    // avoid null undefined on react fields
    const safeNumberValue = value => typeof value === 'number' ? value : '';
    this.setState({
      type,
      formState: {
        data: {
          ...data,
          max_spend_unshipped: safeNumberValue(data.max_spend_unshipped),
          max_spend_lifetime: safeNumberValue(data.max_spend_lifetime),
          max_orders_lifetime: safeNumberValue(data.max_orders_lifetime),
          ordering_days: safeNumberValue(data.ordering_days),
          order_gap: safeNumberValue(data.order_gap),
          max_orders_unshipped: safeNumberValue(data.max_orders_unshipped),
        },
      },
    });
  }

  onFormUpdate(formState, actions) {
    this.setState({
      formState,
    });
  }

  submitForm(formState) {
    const { dispatch, editingLinkedAccount } = this.props;
    const balanceSellingAccount = editingLinkedAccount.balanceSellingAccount;
    dispatch({
      type: 'SAVE_BALANCE_SELLING_ACCOUNT',
      payload: {
        id: balanceSellingAccount && balanceSellingAccount.id,
        type: this.state.type,
        data: formState.data,
      },
    });
  }

  render() {
    return (<LinkedAccountModalView
      {...this.props}
      {...this.state}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
    />);
  }

}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(LinkedAccountModalContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Data/LinkedAccountModal/LinkedAccountModal.container.js